import { z } from "zod";

const CieDetailsSchema = z
  .object({
    reference: z.string(),
    amount: z.string(),
    limit_date: z.string(),
    qr: z.string().optional().nullable(),
    bar_code: z.string().optional().nullable(),
  })
  .transform((api) => ({
    reference: api.reference,
    amount: parseFloat(api.amount),
    limitDate: api.limit_date,
    qr: api.qr,
    barcode: api.bar_code,
  }));

type CieDetails = z.infer<typeof CieDetailsSchema>;

export { CieDetailsSchema, type CieDetails };
